import React, { useState } from "react";
import MainContainer from "../../layout/MainContainer";
import { Box, Button, Card, Tab, Tabs, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { BookingsList } from "../../features";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageBookings = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState<number>(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <MainContainer>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">Manage Property Bookings</h1>
        </div>
        <Card className="cards">
          <Box className="custom_tabs">
            <Box className="flx_sc">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Completed Bookings" {...a11yProps(0)} />
                <Tab label="Cancelled Bookings" {...a11yProps(1)} />
                <Tab label="Ongoing/Upcoming Bookings" {...a11yProps(2)} />
              </Tabs>
              <Button className="btn btn_primary">Export CSV</Button>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <BookingsList value={value} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <BookingsList value={value} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <BookingsList value={value} />
            </CustomTabPanel>
          </Box>
        </Card>
      </div>
    </MainContainer>
  );
};

export default ManageBookings;
